import { render, staticRenderFns } from "./StatisticsPieChart.vue?vue&type=template&id=7e2fb70d&"
import script from "./StatisticsPieChart.vue?vue&type=script&lang=js&"
export * from "./StatisticsPieChart.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsPieChart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports